<template>
    <div class="items-container">
        <!-- v-tooltip se na dotyku nezobrazi (Z2 v roadmap-mobile.md) - trvaly popisek nahore misto -->
        <span class="items-hint">{{ inFight ? $t('trainer.items.fightHint') : $t('trainer.items.hint') }}</span>
        <div v-if="!inFight" class="items-grid">
            <div
                v-for="group in groupedItems"
                :key="group.stackKey"
                class="items-grid__item"
                @click="showDialog(group)"
            >
                <div class="items-grid__icon-wrap">
                    <v-img :src="require(`@/assets/pic${group.picture}`)" contain height="48" width="48" class="item-icon"/>
                    <span v-if="group.count > 1" class="items-grid__count">×{{ group.count }}</span>
                </div>
                <span class="items-grid__name">{{ group.name }}</span>
                <v-icon v-if="group.permanent" size="14" class="items-grid__permanent-icon" title="permanent">mdi-infinity</v-icon>
            </div>
        </div>

        <ResponsiveDialog
            v-if="item"
            v-model="show"
            :max-width="620"
            :full-height="false"
            :header-title="item.name"
            header-class="skin-window-header--oak"
            card-class="skin-card"
        >
            <div class="skin-window--oak items-dialog-bg">
                <v-card-text class="transparent03 justify-center text-center items-dialog-content">
                    <v-img :src="require(`@/assets/pic${item.picture}`)" contain height="90" class="items-dialog-img"/>
                    <v-card-title class="items-dialog-effect">{{ effectDescription(item) }}</v-card-title>

                    <template v-if="item.permanent">
                        <v-row class="d-flex justify-center">
                            <v-col class="d-flex justify-center">
                                {{ $t('trainer.items.permanentHint') }}
                            </v-col>
                        </v-row>
                    </template>

                    <template v-else>
                        <v-col v-if="posiblePokemonsLength > 0" class="d-flex flex-column flex-md-row align-center">
                            <v-carousel
                                v-model="carouselId"
                                height="160"
                                hide-delimiters
                                tile
                            >
                                <v-carousel-item
                                    v-for="pokemon in pokemons"
                                    :key="pokemon.id"
                                >
                                    <v-sheet
                                        class="transparent"
                                        height="100%"
                                    >
                                        <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                        >
                                            <!-- HP kolecko - stejny vzor jako TeamBottomSheet.vue
                                                 (.team-sheet-row-ring/-bg/-sprite) - kdo se leci
                                                 potrebuje vidiet aktualni HP pred vyberem itemu. -->
                                            <div class="items-picker-pokemon">
                                                <div
                                                    class="items-picker-ring"
                                                    :style="{backgroundImage: hpRingGradient(pokemon)}"
                                                >
                                                    <div
                                                        class="items-picker-ring-bg"
                                                        :style="{background: hpBgColor(pokemon)}"
                                                    />
                                                    <v-img :src="pokemonIcon(pokemon)" contain class="items-picker-sprite"/>
                                                </div>
                                                <span class="items-picker-hp-text">{{ pokemon.hp }}/{{ pokemon.maxHp }}</span>
                                            </div>
                                        </v-row>
                                    </v-sheet>
                                </v-carousel-item>
                            </v-carousel>
                        </v-col>

                        <v-row class="d-flex justify-center" v-if="posiblePokemonsLength > 0 && pokemon">
                            <v-btn
                                :loading="loading"
                                color="warning black--text"
                                @click="useItemOnPokemon()"
                            >
                                {{ $t('trainer.items.useButton') }} {{pokemon.name}}
                            </v-btn>
                        </v-row>

                        <v-row class="d-flex justify-center" v-if="posiblePokemonsLength <= 0">
                            <v-col class="d-flex justify-center">
                                {{ noneNeedHeal ? $t('trainer.items.noneNeedHeal') : $t('trainer.items.noPokemon') }}
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </div>
        </ResponsiveDialog>

        <!-- nevratna akce (item se spotrebuje) - noAutoConfirm obchazi autoConfirm prepinac v Options, tohle potvrzeni nejde vypnout -->
        <ConfirmDialog ref="confirmDialog"/>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {Categories} from "@/utils/itemsEnum";
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";
    import ConfirmDialog from "@/components/utils/ConfirmDialog";
    import {pokemonImageSrc} from "@/utils/pokemonImage";

    export default {
        components: {ResponsiveDialog, ConfirmDialog},
        props: {
            items: {type: Array, default: () => []},
            tempPokemons: {type: Array, default: () => []},
            reloadPage: {type: Function, default: () => {}},
            inFight: {type: Boolean, default: false},
        },
        data() {
            return {
                categories: Categories,
                pokemons: [],
                pokemon: null,
                loading: false,
                show: false,
                item: null,
                carouselId: 0,
                itemsList: [],
                posiblePokemonsLength: 0,
                noneNeedHeal: false,
            }
        },
        computed: {
            // Sloucene stejne itemy (stejna kategorie/obrazek/effectValue - viz
            // Kolo ve 4 barvach, ty se sloucit nemaji) do jedne dlazdice s
            // poctem, mimo skutecny seznam ids drzeny primo v itemsList - "id"
            // reprezentanta (prvni polozka ve skupine) se pouziva pri spotrebovani.
            groupedItems() {
                const groups = {};
                const order = [];
                for (const item of this.itemsList) {
                    const key = `${item.category}|${item.picture}|${item.effectValue}`;
                    if (!groups[key]) {
                        groups[key] = {...item, stackKey: key, count: 0};
                        order.push(key);
                    }
                    groups[key].count++;
                }
                return order.map(key => groups[key]);
            },
        },
        watch: {
            carouselId() {
                this.pokemon = this.pokemons[this.carouselId];
            },
            items() {
                this.itemsList = this.items;
            },
        },
        created() {
            this.itemsList = this.items;
        },
        methods: {
            ...mapActions({
                getPokemons: 'trainer/loadPokemons',
                useItem: 'trainer/useItem',
            }),
            effectDescription(item) {
                return this.$t('trainer.items.effects.' + item.category, {value: item.effectValue});
            },
            pokemonIcon(p) {
                return pokemonImageSrc(p.pokemonType.img);
            },
            // Conic-gradient HP kolecko - stejny vzor jako TeamBottomSheet.vue
            // (hpPercent/hpRingGradient/hpBgColor), aby healeni videlo aktualni
            // HP kazdeho pokemona v carouselu, ne jen jeho sprite.
            hpPercent(p) {
                return parseInt(p.hp) / parseInt(p.maxHp) * 100;
            },
            hpRingGradient(p) {
                const pct = Math.max(0, Math.min(100, this.hpPercent(p)));
                return `conic-gradient(#43A047 0% ${pct}%, #E53935 ${pct}% 100%)`;
            },
            hpBgColor(p) {
                return p.endangered ? '#E53935' : '#737373';
            },
            showDialog(item) {
                this.item = item;
                if (item.permanent) {
                    this.show = true;
                    return;
                }
                this.loading = true;
                this.getPokemons(this.tempPokemons).then(
                    (data) => {
                        // Heal itemy nema smysl nabizet na pokemony, co uz maji
                        // plne zivoty - fullHeal() by beztak nic nezmenil (viz
                        // stejny filtr u UseItemButton.vue::usableItems).
                        const isHealEffect = item.effectType === 'HEAL' || item.effectType === 'HEAL_ENDANGERED';
                        this.pokemons = isHealEffect ? data.filter(p => p.hp < p.maxHp) : data;
                        this.noneNeedHeal = isHealEffect && data.length > 0 && this.pokemons.length === 0;
                        this.posiblePokemonsLength = this.pokemons.length;
                        this.loading = false;
                        this.carouselId = 0;
                        this.pokemon = this.pokemons[0];
                        this.show = true;
                    }
                );
            },
            async useItemOnPokemon() {
                let rlyUse = await this.$refs.confirmDialog.open(
                    this.$t('trainer.items.confirmUse', {itemName: this.item.name, pokemonName: this.pokemon.name}),
                    {
                        oak: true,
                        noAutoConfirm: true,
                    }
                );
                if (!rlyUse) {
                    return;
                }
                this.loading = true;
                let obj = {itemId: this.item.id, pokemonId: this.pokemon.id};
                this.useItem(obj).then(
                    () => {
                        this.itemsList = this.itemsList.filter(e => e.id !== this.item.id);
                        this.show = false;
                        this.loading = false;
                        this.reloadPage();
                    }
                ).catch((e) => {
                    this.loading = false;
                    // Popup se vykresluje az v TrainerBag.vue (mimo Swiper) -
                    // position:fixed uvnitr transformovaneho swiper-slide se
                    // pozicuje vuci nemu, ne vuci viewportu (stejny nalez jako
                    // u showLockedStonePopup/Stones.vue).
                    this.$emit('item-use-error', e.message);
                });
            }
        },
    }
</script>

<style scoped>

.items-container {
    width: 100%;
}

.items-dialog-bg {
    display: flex;
    flex-direction: column;
    min-height: 0;
}
/* !important nutne - Vuetify ".v-dialog > .v-card > .v-card__text" ma vyssi specificitu (viz stejny nalez u Stones.vue) */
.items-dialog-content {
    padding-bottom: var(--responsive-dialog-close-clearance) !important;
}
@media (min-width: 960px) {
    .items-dialog-content {
        padding-bottom: 16px !important;
    }
}

.items-dialog-effect {
    font-size: 1em;
    word-break: break-word;
    white-space: normal;
}

.items-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 4px;
}

.items-grid__item {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    width: clamp(70px, 22cqi, 110px);
    padding: 6px 2px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .08);
}

.items-grid__name {
    font-size: 11px;
    text-align: center;
    line-height: 1.2;
}

/* !important na position/top/right nutne - Vuetify ".v-icon.v-icon" ma vyssi specificitu a jinak prebije zpet na staticke umisteni v toku (stejny nalez jako .trainer-bag__tab-star v TrainerBag.vue) */
.items-grid__permanent-icon {
    position: absolute !important;
    top: 2px !important;
    right: 4px !important;
    opacity: .7;
}

/* Wrap kolem obrazku - count badge se pozicuje vuci nemu (48x48, stabilni
   vyska), ne vuci cele dlazdici, jejiz vyska kolisa podle delky nazvu
   (jinak badge prekryval spodek obrazku i text nazvu u delsich jmen). */
.items-grid__icon-wrap {
    position: relative;
    width: 48px;
    height: 48px;
}

.items-grid__count {
    position: absolute;
    bottom: -4px;
    right: -6px;
    font-size: 11px;
    font-weight: 700;
    background-color: rgba(0, 0, 0, .55);
    color: #fff;
    border-radius: 999px;
    padding: 0 5px;
    line-height: 1.5;
}

.items-dialog-img {
    margin: 0 auto 4px;
}

.items-picker-pokemon {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

/* Wrapper s conic-gradient pozadim (viz hpRingGradient v methods) simuluje
   poměrový 2-barevný border - stejný vzor jako TeamBottomSheet.vue
   (.team-sheet-row-ring), jen ve větší velikosti pro tenhle carousel. */
.items-picker-ring {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    padding: 5px;
    box-sizing: border-box;
    position: relative;
}

.items-picker-ring-bg {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

/* Sprite mimo v-avatar (ten by ho ořízl na kruh), absolutně centrovaný přes
   prstenec, o něco větší než ring - vědomě vykukuje přes něj, stejně jako
   TeamBottomSheet.vue (.team-sheet-row-sprite). */
.items-picker-sprite {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 140px;
    height: 140px;
    transform: translate(-50%, -50%);
    z-index: 2;
    pointer-events: none;
}

.items-picker-hp-text {
    font-size: 13px;
    font-weight: 700;
}

.items-hint {
    display: block;
    font-size: 12px;
    line-height: 1.2;
    text-align: center;
    padding: 4px 4px 8px;
}
.theme--light .items-hint {
    color: rgba(0, 0, 0, .7);
}
.theme--dark .items-hint {
    color: rgba(255, 255, 255, .7);
}
</style>
